<template>
  <div>
    <!-- eslint-disable vue/no-v-html -->
    <div
      :class="{ 'message': true, 'message-quick-reply-on-the-right': isFromSubscriber }"
      :style="messageStyles"
    >
      <link-preview-card
        v-if="textMessage.hasLinkPreview()"
        :message="textMessage"
      />
      <div v-html="sanitizedText" />
    </div>
    <!--eslint-enable-->

    <message-sender :message="message" />

    <select-message v-if="isDisplayingCheckboxes" :message="message" />

    <div v-if="isDisplayingButtons" :class="buttonPanelClasses">
      <chatchamp-button
        v-for="(button, index) in buttons"
        :key="index"
        :button="button"
        :message="message"
      />
    </div>
  </div>
</template>

<script>
// @flow

import { mapGetters, mapState } from 'vuex'

import { linkify, sanitizedMarkup, sanitizedText } from '../../../../common/utils'

import { ChatBubbleTextMessage } from '../../../models'
import postMessageMixin from '../../../mixins/postMessageMixin'

import ChatchampButton from '../../ChatchampButton/ChatchampButton.vue'
import LinkPreviewCard from '../../LinkPreviewCard/LinkPreviewCard.vue'
import MessageSender from '../../MessageSender/MessageSender.vue'

import SelectMessage from '../SelectMessage/SelectMessage.vue'

export default {
  components: {
    ChatchampButton,
    SelectMessage,
    LinkPreviewCard,
    MessageSender
  },
  mixins: [postMessageMixin],
  props: {
    message: {
      type: Object, // ChatBubbleMessage<TextContent>
      default: () => {
      }
    }
  },
  data: () => {
    return {
      checkedAttributes: []
    }
  },
  computed: {
    ...mapState(['customerId']),
    ...mapGetters(['primaryColor', 'latestMessage', 'isShowingOpenChat', 'avatarName']),
    textMessage (): ChatBubbleTextMessage {
      return new ChatBubbleTextMessage(this.message)
    },
    buttons (): Array<Object> { // Array<ChatchampButton>
      const buttons = this.message.content?.quick_replies || []

      if (!this.isLatestMessage) return buttons.filter(b => b.type === 'url')

      return buttons
    },
    sanitizedText (): string {
      const text = this.textMessage.getNormalizedText()
      if (this.isFromSubscriber) return sanitizedText(text)

      return linkify(sanitizedMarkup(text, this.message.content.messageId), this.message.content.messageId)
    },
    isDisplayingButtons (): boolean {
      if (this.buttons.length === 0) return false
      if (this.buttons.some(b => b.type === 'url')) return true

      return this.isLatestMessage
    },
    isDisplayingCheckboxes (): boolean {
      const checkboxes = this.message.content?.checkboxes || []

      if (checkboxes.length === 0) return false

      // Only render checkboxes if it's the last message
      return this.latestMessage && this.latestMessage.id === this.message.id
    },
    isFromSubscriber (): boolean {
      return this.customerId === this.message.to
    },
    messageStyles (): Object {
      if (!this.isFromSubscriber && this.isShowingOpenChat) {
        return {
          'text-align': 'center'
        }
      }

      return {}
    },
    isLatestMessage (): boolean {
      return this.latestMessage && this.latestMessage.id === this.message.id
    },
    buttonPanelClasses (): Object {
      return {
        'quick-reply-panel': true,
        'quick-reply-panel--is-from-past-message': !this.isLatestMessage
      }
    }
  }
}
</script>

<style src="./text-message.scss" />
